import { mainGetLiveStock } from "../../../features/main/services/get-live-stock";
import { mainGetPoultries } from "../../../features/main/services/get-poultries";
import { getStewards } from "../../../features/main/services/get-stewards";
import { getInspectionKeys } from "../../../features/main/services/getInspectionKeys";
import { mainGetStewards } from "../../../features/main/services/main-get-stewards";
import { getPoultryScienceForBazresi } from "../../../features/main/services/get-poultry-science";

export const mainExtraReducers = {
  [mainGetStewards.pending]: (state) => {
    state.pending = true;
  },
  [mainGetStewards.fulfilled]: (state, { payload }) => {
    state.stewards = payload.data;
    state.pending = false;
  },
  [getStewards.pending]: (state) => {
    state.pending = true;
  },
  [getStewards.fulfilled]: (state, { payload }) => {
    state.stewardsData = payload.data;
    state.pending = false;
  },
  [getInspectionKeys.fulfilled]: (state, { payload }) => {
    state.inspectionKeys = payload.data;
    state.pending = false;
  },
  [mainGetPoultries.fulfilled]: (state, { payload }) => {
    state.poultryLocations = payload.data;
    state.pending = false;
  },
  [mainGetLiveStock.pending]: (state) => {
    state.pending = true;
  },
  [mainGetLiveStock.fulfilled]: (state, { payload }) => {
    state.liveStockLocations = payload.data;
    state.pending = false;
  },
  [mainGetLiveStock.rejected]: (state) => {
    state.pending = false;
  },
  [getPoultryScienceForBazresi.pending]: (state) => {
    state.pending = true;
  },
  [getPoultryScienceForBazresi.fulfilled]: (state, { payload }) => {
    state.poultryScienceData = payload.data;
    state.pending = false;
  },
  [getPoultryScienceForBazresi.rejected]: (state) => {
    state.pending = false;
  },
};
